import { makeBarGrow, displayStatusIcon, createMoreDetailsSection, statusIconVals } from "../Helpers/DomHelper";
import { updateBlob } from "../Helpers/BlobHelper";
import { cancel } from "../Helpers/ExecutionStatus";
const global = window;
const { selfHelp: { armEndpoint, resources } } = global;
const key = "authToken";
let diagnostics;
let tokenAcquired = false;
/**
 * Ends tests. Updates DOM and BLOB, ensures tests are not ran twice. If cancel has been clicked, will not
 * follow through with functionality.
 */
function endTest() {
    if (cancel) {
        return;
    }
    let iconDisplay;
    if (!tokenAcquired) {
        iconDisplay = statusIconVals.warning;
    }
    else {
        iconDisplay = diagnostics.success ? statusIconVals.success : statusIconVals.error;
    }
    updateBlob(key, diagnostics);
    createMoreDetailsSection(key, diagnostics.details);
    displayStatusIcon(key, iconDisplay);
    makeBarGrow(key);
}
/**
 * Checks whether authentication token is being stripped when making a request to a known resource
 *
 * @param authHeader the authentication header needed to make the request
 */
function checkAuthHeaderStripped(authHeader) {
    if (cancel) {
        return;
    }
    new Promise((resolve, reject) => {
        if (cancel) {
            return;
        }
        if (!armEndpoint) {
            diagnostics.success = false;
            diagnostics.details = resources.Auth_endpointUnavailable;
        }
        const version = "2019-10-01";
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (cancel) {
                return;
            }
            if (this.readyState === 4) {
                const { status, statusText } = xhr;
                diagnostics.status = status;
                diagnostics.statusText = statusText;
                if (status >= 200 && status < 300) {
                    diagnostics.success = true;
                    diagnostics.details = resources.Auth_tokenRequestSuccess.replace("{0}", status.toString());
                    resolve(endTest());
                }
                else {
                    diagnostics.success = false;
                    diagnostics.details = resources.Auth_tokenRequestFailure.replace("{0}", status.toString());
                    if (status === 0) {
                        diagnostics.details += ` ${resources.Endpoint_statusZeroInfo}`;
                    }
                    reject(endTest());
                }
            }
        };
        xhr.open("GET", `${armEndpoint}/locations?api-version=${version}`, true);
        xhr.setRequestHeader("Authorization", authHeader);
        xhr.send();
    });
}
/**
 * Creates an iFrame which checks whether user authentication can be validated and grabs
 * the token from session storage.
 */
function checkAuth() {
    // if storage event listener is not triggered, we are likely in incognito mode and test will fail
    let storageEventListenerTriggered = false;
    const iframe = document.createElement("iframe");
    iframe.setAttribute("tabindex", "-1");
    const iFrameLoginDiv = document.getElementById("shdid-hidden-auth-iFrame");
    iFrameLoginDiv.appendChild(iframe);
    iframe.src = `./signin/index/?silentSignIn=true`;
    const retreiveAuthToken = (event) => {
        storageEventListenerTriggered = true;
        const authStateJSON = sessionStorage.getItem("authState");
        // auth state is added to session storage by iframe twice
        // tokenAcquired boolean keeps this function from being triggered every time the storage object is updated
        if (authStateJSON && !tokenAcquired) {
            tokenAcquired = true;
            const { oAuthToken: { authHeader } } = JSON.parse(authStateJSON);
            document.cookie = `oauth-token=${authHeader}`;
            checkAuthHeaderStripped(authHeader);
        }
    };
    window.addEventListener("storage", retreiveAuthToken);
    // After 20 seconds without grabbing the authentication token, trigger timeout
    setTimeout(() => {
        if (!tokenAcquired && !storageEventListenerTriggered) {
            diagnostics = {
                success: null,
                details: resources.Auth_tokenFailIncognito,
            };
            endTest();
        }
        else if (!tokenAcquired) {
            diagnostics = {
                success: null,
                details: resources.Auth_tokenFetchError,
            };
            endTest();
        }
        iframe.remove();
        window.removeEventListener("storage", retreiveAuthToken);
    }, 20000);
}
/**
 * Triggers test start and updates DOM. Sets "testFinished" as false in case this is the second
 * time test is ran.
 */
export function startTest() {
    diagnostics = { success: null, details: null };
    tokenAcquired = false;
    displayStatusIcon(key, statusIconVals.inProgress);
    checkAuth();
}
//# sourceMappingURL=AuthDiagnostics.js.map